import React, { FC, useCallback, useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";
import {
  getAttachmentsAndComments,
} from "../../../services/jira.service";
import moment from "moment";
import "./style.scss";
import { getUserActivityCommentsOpenProject } from "../../../services/user.service";
type CommentsPopupProps = {
  open: boolean;
  platform: string;
  handleClose: () => void;
  issueKey: string[];
};

const CommentsPopup: FC<CommentsPopupProps> = ({
  open,
  handleClose,
  platform,
  issueKey,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [comments, setComments] = useState<any[]>([]);

  const handleComments = useCallback(async (
    issueKey: string[],
    platform: string
  ) => {
    setIsLoading(true);
    if (issueKey.length) {
      if(platform === "JIRA"){
        const attachmentsCommentsResp = await getAttachmentsAndComments(
          issueKey[0]
        );
  
        if (
          attachmentsCommentsResp?.comment &&
          attachmentsCommentsResp?.comment?.comments?.length
        ) {
          const comments = attachmentsCommentsResp?.comment?.comments?.map(
            (comm: any) => ({
              content: comm?.body,
              updatedAt: moment(comm?.updated)?.format("YYYY-MM-DD HH:mm"),
              author: comm?.author?.displayName,
              avatar: comm?.author?.avatarUrls["32x32"],
            })
          );
  
          const commentTab = comments.filter(
            (e: any) => !e.content.includes("Waymore Meet")
          );
  
          setComments(commentTab);
        } else {
          setComments([]);
        }
      }else if(platform === "OPEN_PROJECT"){
        const commentsRepsonseOpenProject = await getUserActivityCommentsOpenProject("comments", issueKey[0], platform);
        if(commentsRepsonseOpenProject.statusCode === 200 && commentsRepsonseOpenProject.data.length ){
          const commentsListFiltered = commentsRepsonseOpenProject?.data.map((comm:any)=> ({
              content:comm?.comment?.html,
              updatedAt:moment(comm?.createdAt)?.format('YYYY-MM-DD HH:mm'),
              author: comm?.user?.name,
              avatar: comm?.user?.avatar,
          }));
          const commentTab = commentsListFiltered.filter(
            (e: any) => !e.content.includes("Waymore Meet")
          );
  
          setComments(commentTab);
        } else {
          setComments([]);
        }
      }
    }
    setIsLoading(false);
  }, []);
  useEffect(() => {
    if (open) {
        handleComments(issueKey, platform);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const onCloseHandler = () => {
    if (isLoading) return;
    handleClose();
    setIsLoading(false);
    setTimeout(() => setComments([]), 500);
  };

  const processStringWithLinks = useCallback(
    (str: string = ""): React.ReactNode[] => {
      const urlRegex = /(https?:\/\/[^\s|]+)/g;
  
      return str.split(urlRegex).map((part, index) => {
        if (part.match(urlRegex)) {
          return (
            <a
              href={part}
              key={index}
              target="_blank"
              rel="noopener noreferrer"
            >
              {part}
            </a>
          );
        }
  
        // Handle line breaks properly
        return part.split("\n").map((line, lineIndex) => (
          <React.Fragment key={`${index}-${lineIndex}`}>
            {line}
            {lineIndex < part.split("\n").length - 1 && <br />}
          </React.Fragment>
        ));
      });
    },
    []
  );
  
  const sanitizeLinks = useCallback((htmlContent: string) => {
    if (!htmlContent) return "";
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, "text/html");
    const links = doc.querySelectorAll("a");
  
    links.forEach((link) => {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
    });
  
    return doc.body.innerHTML;
  }, []);
  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={onCloseHandler}
      >
        <DialogTitle>Comments for {issueKey}</DialogTitle>
        <DialogContent>
          {isLoading ? (
            <Box display={'flex'} justifyContent={'center'}>
              <CircularProgress size={"3rem"} />
            </Box>
          ) : (
            <div className="issue-command">
                <div className="issue-command-contant">
                  {comments.length === 0 && <div>No Comments yet</div>}
                  {comments?.map((command, index) => {
                    if (command && command.author) {
                      return (
                        <div key={index} className="comment-avatar">
                          <img
                            width={"32px"}
                            height={"32px"}
                            src={command?.avatar}
                            alt={command?.author}
                            loading="lazy"
                            style={{ borderRadius: "50%" }}
                          />
                          <div style={{ width: "90%" }}>
                            <span>
                              <b>{command?.author}</b>
                            </span>{" "}
                            <span>{command.updatedAt}</span>
                            <div className="issue-command-item">
                              {platform === "JIRA" ? processStringWithLinks(command?.content || "") : <div
                                key={index}
                                className="issue-comment"
                                dangerouslySetInnerHTML={{
                                  __html: sanitizeLinks(command?.content) || "",
                                }}
                              />}
                            </div>
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div
                          key={index}
                          className="issue-comment"
                          dangerouslySetInnerHTML={{
                            __html: sanitizeLinks(command?.content) || "",
                          }}
                        />
                      );
                    }
                  })}
                </div>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            disabled={isLoading}
            variant="contained"
            onClick={onCloseHandler}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CommentsPopup;
